import React from 'react';
import { formatTimeDifference } from '../../../lib/utils/utils';

function NotificationItem({ notification }) {
    return (
        <div className="select-none flex items-center gap-2 border-b border-[#EAEAEA] p-2">
            {/* <div className="min-w-11 max-w-11 h-11 rounded overflow-hidden">
                <img className='w-full h-full object-cover' src='' alt="" />
            </div> */}

            {notification.message.type === 'invitation' && 
                <div className="size-[46px] bg-[#EAEAEA] rounded-full flex items-center justify-center">
                    <h1 className='font-mulish font-bold text-base text-[#666666]'>{notification.message.msg.split("by")[1].trim().split(' ').slice(0, 2).map(word => word[0].toUpperCase()).join('')}</h1>
                </div>
            }

            <h1 className="text-[14px] leading-[22px] text-[#121212]">
                {notification.message.msg}
            </h1>

            <span className="ml-auto font-medium text-[14px] leading-5 text-[#808080]">
                {formatTimeDifference(notification.createdAt)}
            </span>
        </div>
    );
}

export default NotificationItem;
